import type { ReactNode } from 'react';
import { Dropdown } from 'react-bootstrap';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function FilterChip({
  icon,
  label,
  active = false,
  children,
  align = 'start',
}: {
  icon: ReactNode;
  label: string;
  active?: boolean;
  children: ReactNode;
  align?: 'start' | 'end';
}) {
  return (
    <Dropdown align={align}>
      <Dropdown.Toggle
        as="button"
        className={classNames(
          'btn d-inline-flex align-items-center gap-1 rounded-pill border px-2 py-1 fs--2 fw-medium lh-sm',
          active
            ? 'bg-body text-1000 border-400 shadow-sm'
            : 'bg-body-tertiary text-700 border-300',
        )}
      >
        <span className="text-500 d-inline-flex">{icon}</span>
        <span className="text-truncate" style={{ maxWidth: '9rem' }}>
          {label}
        </span>
      </Dropdown.Toggle>
      <Dropdown.Menu style={{ minWidth: 200, maxHeight: 320, overflowY: 'auto' }} className="py-1">
        {children}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export function FilterMenuItem({
  selected,
  onClick,
  leading,
  children,
}: {
  selected?: boolean;
  onClick: () => void;
  leading?: ReactNode;
  children: ReactNode;
}) {
  return (
    <Dropdown.Item
      onClick={onClick}
      active={selected}
      className="d-flex align-items-center gap-2 fs--1"
    >
      <span
        className="d-flex flex-shrink-0 align-items-center justify-content-center"
        style={{ width: '1rem', height: '1rem' }}
      >
        {selected ? <FontAwesomeIcon icon="check" className="fs--2" /> : null}
      </span>
      {leading ? <span className="flex-shrink-0">{leading}</span> : null}
      <span className="text-truncate">{children}</span>
    </Dropdown.Item>
  );
}

export function CalendarIcon() {
  return <FontAwesomeIcon icon="calendar" className="fs--2" />;
}

export function ModelIcon() {
  return <FontAwesomeIcon icon="robot" className="fs--2" />;
}

export function DomainIcon() {
  return <FontAwesomeIcon icon="globe" className="fs--2" />;
}

export function TopicIcon() {
  return <FontAwesomeIcon icon="folder" className="fs--2" />;
}
